var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 10,
    fill: "#E6F2EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9965 12C17.8108 11.9991 17.6248 12.0751 17.4912 12.228L12.8312 17.5614C12.5889 17.8386 12.6173 18.2598 12.8945 18.502C13.1718 18.7443 13.5929 18.7159 13.8352 18.4386L17.3332 14.4353V23.3333C17.3332 23.7015 17.6317 24 17.9998 24C18.368 24 18.6665 23.7015 18.6665 23.3333V14.4467L22.1651 18.4394C22.4078 18.7163 22.8289 18.7441 23.1059 18.5014C23.3828 18.2588 23.4106 17.8376 23.1679 17.5606L18.5516 12.2923C18.4316 12.1159 18.2293 12 17.9998 12L17.9965 12Z",
    fill: "#077D3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxup);
export default __webpack_public_path__ + "static/media/boxup.22b23f74f36fad03cbbe239b5163e023.svg";
export { ForwardRef as ReactComponent };